import React from 'react';
import { connect } from 'react-redux';
import { removeNotification } from '../utilsActions';
import { withSnackbar } from 'notistack';

// slight clean up of: https://github.com/iamhosseindhv/notistack/issues/8

class NotificationsRedux extends React.Component {
  state = {
    displayed: [],
  };

  setNotifications = () => {
    const { notifications, removeNotification } = this.props;
    const { displayed } = this.state;

    notifications.map(notification => {
      setTimeout(() => {
        if (displayed.filter(index => index === notification.index).length > 0) {
          return;
        }

        this.props.enqueueSnackbar(notification.message, { variant: notification.variant });
        this.setState({ displayed: [...this.state.displayed, notification.index] });
        removeNotification(notification.index);
      }, 300);

      return true;
    });
  };

  render() {
    this.setNotifications();
    return null;
  }
}

const mapStateToProps = ({ utils }) => ({
  notifications: utils.notifications,
});

const mapDispatchToProps = {
  removeNotification,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(NotificationsRedux));



// WEBPACK FOOTER //
// ./src/utils/Notifications/NotificationsRedux.js